import script from "./ForceChangePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ForceChangePassword.vue?vue&type=script&setup=true&lang=js"

import "./ForceChangePassword.vue?vue&type=style&index=0&id=39002dfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39002dfc"]])

export default __exports__